/**
 * Shared validation helpers for the public QuickCollect guest form.
 *
 * The email pattern is used by both the inline field validation in
 * QuickCollectFormSection and the submit-time check in QuickCollectContainer,
 * so the two can never disagree. This only checks the format -- it does not
 * verify that the address actually exists.
 *
 * See docs/QUICKCOLLECT_IMPLEMENTATION.md
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) =>
  EMAIL_PATTERN.test(String(value || "").trim());
